/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUserPermissionRelationDto
 */
export interface UpdateUserPermissionRelationDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPermissionRelationDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPermissionRelationDto
     */
    permission?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserPermissionRelationDto
     */
    relation?: boolean;
}

export function UpdateUserPermissionRelationDtoFromJSON(json: any): UpdateUserPermissionRelationDto {
    return UpdateUserPermissionRelationDtoFromJSONTyped(json, false);
}

export function UpdateUserPermissionRelationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserPermissionRelationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'permission': !exists(json, 'permission') ? undefined : json['permission'],
        'relation': !exists(json, 'relation') ? undefined : json['relation'],
    };
}

export function UpdateUserPermissionRelationDtoToJSON(value?: UpdateUserPermissionRelationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'permission': value.permission,
        'relation': value.relation,
    };
}


